// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf-8,<svg width=\"24\" height=\"24\" role=\"presentation\" focusable=\"false\" version=\"1.2\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3 5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5ZM5 6C5 5.44772 5.44772 5 6 5H10C10.5523 5 11 5.44772 11 6V16C11 16.5523 10.5523 17 10 17H6C5.44772 17 5 16.5523 5 16V6ZM14 5C13.4477 5 13 5.44772 13 6V12C13 12.5523 13.4477 13 14 13H18C18.5523 13 19 12.5523 19 12V6C19 5.44772 18.5523 5 18 5H14Z\" fill=\"currentColor\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BNa7Ti6eVbkqiK {
  width: 24px;
  height: 14px;
  border-radius: 4px;
}
.ZebSbjqBEOXtUC {
  width: 24px;
  height: 24px;
  border-radius: 6px;
}
.ko0j2cZfnAzCtP {
  width: 20px;
  height: 20px;
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  mask-size: cover;
  object-fit: cover;
}
.UUb8v62S6ICrFV {
  object-fit: cover;
}
.ehccKo0ixRTWsB {
  width: 20px;
  height: 20px;
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  mask-size: cover;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"compact": `BNa7Ti6eVbkqiK`,
	"expanded": `ZebSbjqBEOXtUC`,
	"cardFrontBoardChipBoardIconImage": `ko0j2cZfnAzCtP`,
	"cardFrontBoardChipBoardIconShowListName": `UUb8v62S6ICrFV`,
	"cardFrontBoardChipBoardIconColor": `ehccKo0ixRTWsB`
};
export default ___CSS_LOADER_EXPORT___;
